export const DASHBOARD_GRID_STEP = 7
export const DASHBOARD_GRID_BACKGROUND_SIZE = 14

export const DASHBOARD_GRID_COLUMNS = 176
export const DASHBOARD_MOBILE_LAYOUT_COLUMNS = 47
export const DASHBOARD_GRID_MAX_WIDTH = DASHBOARD_GRID_COLUMNS * DASHBOARD_GRID_STEP

export const DASHBOARD_WIDGET_GAP_COLUMNS = 4
export const DASHBOARD_WIDGET_GAP_ROWS = 4

export const DASHBOARD_GRID_MARGIN = [0, 0] as const
export const DASHBOARD_GRID_CONTAINER_PADDING = [0, 0] as const

export function getDashboardGridMetrics(containerWidth: number) {
  const columns = Math.max(
    1,
    Math.min(DASHBOARD_GRID_COLUMNS, Math.floor(containerWidth / DASHBOARD_GRID_STEP))
  )

  return {
    columns,
    width: columns * DASHBOARD_GRID_STEP,
  }
}
